export enum SetNewPasswordFormEnums {
  IMAGE_ALT = 'Carbon one',
  HEADING = 'Set new password',
  SUBHEADING = 'When you login next time,use the new password to login',
  BUTTON_LABEL_SUBMIT = 'Confirm',
}